// extracted by mini-css-extract-plugin
export default {"root":"styles_root__gMQQd","input":"styles_input__yJqdY","placeholder":"styles_placeholder__kbv01","placeholderActive":"styles_placeholderActive__0E84L"};